'use strict';
var mediaQueryString = '(max-width: 700px)';
var isMobile = window.matchMedia(mediaQueryString);
window.pushpay.isMobile = isMobile.matches;
